export const processImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  const response = await fetch("/api/compute-embedding/", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Failed to compute embedding");
  }

  const data = await response.json();
  return data.embedding;
};
